export const sendEventToGTM = (parameter: { event: string }) => {
  if (!window) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: parameter.event,
  });
};
